import { mapState } from 'vuex'
import { DateTime } from 'luxon'
import { get } from 'lodash'
import { getPositionsLean, getAllowedPlans } from '@/lib/api.js'
import BarLoading from '@/views/components/core/BarLoading.vue'
import TaxGuideAlert from '@/views/components/tax/TaxGuideAlert'
import TaxDisclaimer from '@/views/components/tax/TaxDisclaimer'
import TaxSomePositionRecreating from '@/views/components/tax/TaxSomePositionRecreating'
import SomePositionIncomplete from '@/views/components/common/positions/SomePositionIncomplete.vue'
import gtag from '@/lib/gtag'

export default {
  components: {
    BarLoading,
    TaxGuideAlert,
    TaxDisclaimer,
    TaxSomePositionRecreating,
    SomePositionIncomplete,
  },
  data: () => ({
    yearsToSelect: null,
    yearSelected: null,
    loadTimeout: null,
    loading: false,
    somePendingRecreatePosition: false,
    hideDataNoPlanUser: false,
  }),
  watch: {
    yearSelected: {
      async handler() {
        await this.updateData()
      },
    },
  },
  async destroyed() {
    clearTimeout(this.loadTimeout)
  },
  mounted() {
    this.getHideDataNoPlanUser()
  },
  computed: {
    ...mapState(['user']),
    startDate() {
      const yearDt = DateTime.fromObject({ year: this.yearSelected })
      return yearDt.startOf('year').toISO()
    },
    endDate() {
      const yearDt = DateTime.fromObject({ year: this.yearSelected })
      return yearDt.endOf('year').toISO()
    },
  },
  methods: {
    async init() {
      const positions = await getPositionsLean({
        filter: {},
      })
      this.somePendingRecreatePosition = positions.data.some(
        (item) => item.corePendingRecreate || item.coreStatus !== 'recreated'
      )

      if (!this.somePendingRecreatePosition) {
        await this.loadData(this.startDate, this.endDate)
      }

      clearTimeout(this.loadTimeout)
      if (this.somePendingRecreatePosition) {
        this.loadTimeout = setTimeout(() => {
          this.init()
        }, 5000)
      }
    },
    async updateData() {
      this.loading = true
      try {
        await this.init()
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }
      this.loading = false
    },
    yearClicked(year) {
      gtag.pageview({
        pagePath: `/tax/${this.tab}`,
        pageTitle: `tax|${this.tab}`,
        pageContentGroup: 'page',
        extraParams: {
          filter: `year|${year}`,
        },
      })
    },
    async getHideDataNoPlanUser() {
      if (['NO_PLAN', 'TRIAL'].indexOf(this.user.status) === -1) {
        this.hideDataNoPlanUser = false
        return
      }

      const result = await getAllowedPlans()
      const allowedPlans = get(result, 'data.allowedPlans', undefined)
      if (!allowedPlans) {
        this.hideDataNoPlanUser = false
        return
      }

      const noPlan = allowedPlans.find((elem) => elem.plan === 'noPlan')
      this.hideDataNoPlanUser = !noPlan.allowed
    },
  },
}
